import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import {CustomDialogComponent} from './custom-dialog.component';
import {CommonModule} from '@angular/common';

@NgModule({
    declarations: [
        CustomDialogComponent
    ],
    imports: [
        MatDialogModule,
        MatButtonModule,
        CommonModule
    ],
    entryComponents: [
        CustomDialogComponent
    ],
})
export class CustomDialogModule
{
}
